import React from "react";
import { useNavigate } from "react-router-dom";
import AppLogo from "../../AppLogo";
import LanguageSwitcher from "../LangChanger";

const Authlayout = ({ children }) => {
  const navigate = useNavigate();
  return (
    <div className="relative">
      <div className="bg-black h-screen w-screen">
        <div className="absolute h-fit w-full sm:block hidden bg-neutral-900 mb-20 overflow-hidden z-10">
          <div className="px-7 py-3 flex gap-3 items-center h-14 justify-between w-full">
            <button
              type="button"
              className="h-9 pr-1 flex gap-3 items-center cursor-pointer"
              // onClick={onClickLogo}
            >
              <AppLogo />
            </button>
            <div className="z-50">
              <LanguageSwitcher />
            </div>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Authlayout;
